export const wrap = (i: number, len: number) => ((i % len) + len) % len
